import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Theme from "./Theme.js";
import Layout from "./Layout.js";
import S from './Content.css';

/** 
 * has a header, content and footer. 
 * @property {string} className - css class to be applied to this component 
 * @property {boolean} horizontal 
 * @property {boolean} inline 
 * @property {boolean} relative 
 * @property {boolean} vFill 
 * */
import { jsx as _jsx } from "react/jsx-runtime";
class Content extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    horizontal: PropTypes.bool,
    inline: PropTypes.bool,
    relative: PropTypes.bool,
    vFill: PropTypes.bool
  };
  static defaultProps = {
    className: null,
    horizontal: false,
    inline: false,
    relative: false,
    vFill: false
  };
  static contextType = Theme.Context;
  render() {
    const theme = this.context;

    // eslint-disable-next-line no-unused-vars
    const {
      className,
      variant,
      horizontal,
      inline,
      relative,
      vFill,
      layoutOptions,
      domRef,
      ...rest
    } = this.props;
    const vc = variant ? theme.classes('Pane', 'pane', variant) : null;
    const cn = classNames(S.content, horizontal && S.horizontal, relative && S.relative, vFill && S.vFill, inline && S.inline, vc, className);
    return /*#__PURE__*/_jsx("div", {
      className: cn,
      ref: domRef,
      ...rest
    });
  }
}
class Header extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: null
  };
  static contextType = Theme.Context;
  render() {
    const theme = this.context;
    const {
      className,
      variant,
      layout,
      children,
      domRef,
      ...rest
    } = this.props;
    const lcn = Layout.classes(theme, layout);
    const vc = variant ? theme.classes('Pane', 'pane', variant) : null;
    return /*#__PURE__*/_jsx("div", {
      className: classNames(S.header, className, vc, lcn),
      ref: domRef,
      ...rest,
      children: Layout.renderLayout(this.context, layout, children)
    });
  }
}
class Area extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    fill: PropTypes.string
  };
  static defaultProps = {
    className: null,
    fill: null
  };
  static contextType = Theme.Context;
  render() {
    const theme = this.context;
    const {
      className,
      layout,
      children,
      fill,
      variant,
      domRef,
      ...rest
    } = this.props;
    const fName = fill === true || fill === 'both' ? S.fill : fill === 'height' ? S.fillHeight : fill === 'width' ? S.fillWidth : null;
    const lcn = Layout.classes(theme, layout);
    const vc = variant ? theme.classes('Pane', 'pane', variant) : null;
    return /*#__PURE__*/_jsx("div", {
      className: classNames(S.area, fName, className, vc, lcn),
      ref: domRef,
      ...rest,
      children: Layout.renderLayout(this.context, layout, children)
    });
  }
}
class Footer extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: null
  };
  static contextType = Theme.Context;
  render() {
    const theme = this.context;
    const {
      className,
      layout,
      children,
      variant,
      domRef,
      ...rest
    } = this.props;
    const lcn = Layout.classes(theme, layout);
    const vc = variant ? theme.classes('Pane', 'pane', variant) : null;
    return /*#__PURE__*/_jsx("div", {
      className: classNames(S.footer, className, vc, lcn),
      ref: domRef,
      ...rest,
      children: Layout.renderLayout(this.context, layout, children)
    });
  }
}
Content.Header = Header;
Content.Area = Area;
Content.Footer = Footer;
export default Content;